import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Work from "@/components/site/Work";
import Coaching from "@/components/site/Coaching";
import Speaking from "@/components/site/Speaking";
import Press from "@/components/site/Press";
import Services from "@/components/site/Services";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((e) => e.classList.add("in-view"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -10% 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <main className="font-body bg-white text-[#0A0A0A]" data-testid="home-page">
      <Navbar />
      <Hero />
      <Work />
      <Coaching />
      <Speaking />
      <Press />
      <Services />
      <Booking />
      <Footer />
    </main>
  );
}
